var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.0935L12 17.0935L10.5 18.5935C10.1737 18.9306 9.7835 19.1994 9.35225 19.3842C8.921 19.569 8.45728 19.6662 7.98811 19.67C7.51894 19.6738 7.0537 19.5842 6.6195 19.4064C6.18531 19.2286 5.79084 18.9662 5.45907 18.6344C5.12731 18.3027 4.86489 17.9082 4.6871 17.474C4.50931 17.0398 4.41971 16.5746 4.42352 16.1054C4.42733 15.6362 4.52447 15.1725 4.70928 14.7413C4.8941 14.31 5.16289 13.9198 5.5 13.5935L7 12.0935Z",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.0935L12 7.09351L13.5 5.59351C13.8263 5.2564 14.2165 4.98761 14.6477 4.80279C15.079 4.61798 15.5427 4.52084 16.0119 4.51703C16.4811 4.51322 16.9463 4.60282 17.3805 4.78061C17.8147 4.95839 18.2092 5.22082 18.5409 5.55258C18.8727 5.88435 19.1351 6.27882 19.3129 6.71301C19.4907 7.14721 19.5803 7.61245 19.5765 8.08162C19.5727 8.55079 19.4755 9.01451 19.2907 9.44576C19.1059 9.87701 18.8371 10.2672 18.5 10.5935L17 12.0935Z",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.0935L5.5 18.5935",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.59351L21 3.09351",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.0935L8 13.0935",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.0935L11 16.0935",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCables);
export default __webpack_public_path__ + "static/media/cables.496638c5227d320fa29b858233fed8f0.svg";
export { ForwardRef as ReactComponent };